import type { GetProductTagsPropsProps } from '@ab-core/producttags';
import { getFallbackState, getProductTagsProps, ProductTags } from '@ab-core/producttags';
import type { FC } from 'react';
import React from 'react';
import type { ScalableStyle } from '../../scalableStyles';
import { FallbackWrapper } from './index.styled';

export type TagsContainerStyleType = ScalableStyle<{
    isVisible: boolean;
}>;

export type TagsContainerProps = {
    product?: GetProductTagsPropsProps['product'];
};

export const TagsContainer: FC<TagsContainerProps & TagsContainerStyleType> = (props) => {
    const { product, scalableStyle } = props;
    const tags = product ? getProductTagsProps({ product }) : undefined;

    const showTags = tags && scalableStyle?.isVisible;
    const fallBackTags = getFallbackState(tags) && scalableStyle?.isVisible;

    return (
        <div>
            {showTags && <ProductTags {...tags} />}
            {fallBackTags && <FallbackWrapper />}
        </div>
    );
};
